export const handleImage = (image) => {
  if (!image?.includes("http")) {
    if (!image?.startsWith("/")) image = `/${image}`;
    return `${process.env.REACT_APP_URL}${image}`;
  }
  return image || "";
  // return "https://picsum.photos/seed/picsum/200/300";
};
export const getId = (obj) => obj?._id || obj?.id;

export const handleSearchParamsChange = (search, params) => {
  const url = new URLSearchParams("");
  search = { ...search, ...params };
  Object.entries(search).map(([key, value]) => {
    return url.set(key, value);
  });
  return "?" + url;
};

export const themeSwitcherFunction = () => {
  document.querySelector(".themetoggle").classList.toggle("fire");
  document.querySelector("body").classList.toggle("dark");
};

export const sidebarToggleFunction = () => {
  document.querySelector("body").classList.remove("sidebarToggled");
  document.querySelector(".overlay-s").classList.remove("fire");
  document.querySelector("html").classList.remove("offScroll");
};

export const getSettingsBySlug = (settings, slug) => {
  return settings.find((setting) => {
    return setting._id === slug;
  });
};

export const getToday = () => {
  let today = new Date();
  let dd = String(today.getDate());
  let mm = String(today.getMonth() + 1); //January is 0!
  let yyyy = today.getFullYear();

  today = `${yyyy}-${mm}-${dd}`;
  return today;
};

export const getDateOfBirthWithFormat = (date) => {
  let newDateWithFormate = new Date(date);

  let dd = String(newDateWithFormate.getDate()).padStart(2, "0");
  let mm = String(newDateWithFormate.getMonth() + 1).padStart(2, "0");
  let yyyy = newDateWithFormate.getFullYear();

  newDateWithFormate = `${yyyy}-${mm}-${dd}`;
  return newDateWithFormate;
};

export const selctOptionValues = (options, selectedOption) => {
  const option = options?.find((option) => option?.value === selectedOption);

  return option;
};

export const handleSkillsDefaultValues = (options) => {
  return options?.map((option) => {
    return {
      value: option?.id,
      label: option?.name,
    };
  });
};

export const imageTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/jpg",
  "image/webp",
];
export const videoTypes = ["video/mp4", "video/mov", "video/avi"];

export const checkFileType = (file) => {
  let type = "img";

  // Check MIME type
  if (imageTypes.includes(file?.type)) {
  } else if (videoTypes.includes(file?.type)) {
    type = "video";
  } else {
    // Check file extension
    const extension = file?.split(".").pop().toLowerCase();
    if (extension === "jpg" || extension === "png" || extension === "gif") {
    } else if (
      extension === "mp4" ||
      extension === "mov" ||
      extension === "avi"
    ) {
      type = "video";
    } else {
      console.log("File is neither an image nor a video");
    }
  }

  return type;
};
